import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-back" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "設定状況", -1)
const _hoisted_8 = { class: "p-recommend-inner -is-mail-security-1" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"p-mail-security-block\"><h1 class=\"p-login-heading-2 u-mb-10-sp u-mb-16-pc p-mail-security-setting-view__title\">マイナビ転職AGENTにおける<br class=\"u-lg-hidden\">セキュリティ強化について</h1><p class=\"u-text-center u-mb-10-sp u-mb-16-pc p-mail-security-setting-view__description\">マイナビ転職AGENTではセキュリティの強化を目的に<br>2点の仕様変更を行いました。</p><div class=\"p-mail-security-box1\"><ul class=\"p-mail-security-list1 --numbered --fit-content\"><li>ログインIDとメールアドレス1が同一となるように仕様変更を実施</li><li>ご本人様確認としてメールアドレス認証を追加</li></ul></div></div>", 1)
const _hoisted_10 = { class: "p-mail-security-block" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "p-login-heading-2 u-mb-8" }, [
  /*#__PURE__*/_createTextVNode("ログインID・メールアドレス"),
  /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }),
  /*#__PURE__*/_createTextVNode("設定状況について")
], -1)
const _hoisted_12 = { class: "u-text-center --type-1 u-mb-8" }
const _hoisted_13 = {
  key: 0,
  class: "p-mail-security-notice --error"
}
const _hoisted_14 = { class: "p-mail-security-email-list1" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "p-mail-security-email-list1__content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "ログインID", -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "p-mail-security-email-list1__content" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス1", -1)
const _hoisted_21 = { class: "p-mail-security-email-list1__icon" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "p-mail-security-email-list1__content" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス2", -1)
const _hoisted_25 = { class: "p-mail-security-email-list1__icon" }
const _hoisted_26 = { class: "p-mail-security-block" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "設定する", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "l-wrapper_nav" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import Loading from '@/components/Loading.vue';
import { MailSecurityInfoDetail } from '@/types/emailSerurity';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecuritySettingView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);
const emailSecutiryInfo = ref<MailSecurityInfoDetail|undefined>();

onMounted(async () => {
  await store.dispatch('mailSecurity/receive');
  emailSecutiryInfo.value = store.getters['mailSecurity/mailSecurity'];
});

const goToMailSecutityFormScreen = () => {
  router.push({
    name: 'mss03',
    query: {
      from: 'mail-security-setting'
    }
  });
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).back()), ["prevent"]))
          }, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", _hoisted_12, _toDisplayString(`${emailSecutiryInfo.value?.lastName}${emailSecutiryInfo.value?.firstName}`) + "さまの登録情報は次の通りです。", 1),
            (emailSecutiryInfo.value?.loginId != emailSecutiryInfo.value?.email1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "ログインIDとメールアドレス1は一致していません。"))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_14, [
              (Boolean(emailSecutiryInfo.value?.loginId))
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _createElementVNode("dl", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("dd", null, _toDisplayString(emailSecutiryInfo.value?.loginId), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (Boolean(emailSecutiryInfo.value?.email1))
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                    _createElementVNode("dl", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("dd", null, _toDisplayString(emailSecutiryInfo.value?.email1), 1)
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(emailSecutiryInfo.value?.email1AuthFlg == 1 ? "認証済" : "未認証"), 1)
                  ]))
                : _createCommentVNode("", true),
              (Boolean(emailSecutiryInfo.value?.email2))
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                    _createElementVNode("dl", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("dd", null, _toDisplayString(emailSecutiryInfo.value?.email2), 1)
                    ]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(emailSecutiryInfo.value?.email2AuthFlg == 1 ? "認証済" : "未認証"), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("a", {
              class: "p-recommend-button --type-1 --width-1",
              href: "",
              onClick: _withModifiers(goToMailSecutityFormScreen, ["prevent"])
            }, _hoisted_29, 8, _hoisted_27)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_33, 8, _hoisted_31)
    ]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})